import React, { useState } from 'react';
import './ModuleTemplate.css';

const ModuleTemplate = ({ 
  children,
  onBack,
  progress = [],
  totalQuestions = 0,
  disabled = false,
  extraContent,
  onStartPause,
  forceStop = false, 
  onComplete,
  onRepeat,         
  extraButtons
}) => {
  const [isRunning, setIsRunning] = useState(false);

  const handleForceStop = () => {
    if (onComplete) {
      onComplete();
    } else {
      onBack();
    }
  };

  const handleMainBtnClick = () => {
    if (isRunning) {
      setIsRunning(false);
      if (onStartPause) onStartPause('pause');
    } else {
      setIsRunning(true);
      if (onStartPause) onStartPause('start');
    }
  };

  const isRunningColor = { bg: 'linear-gradient(180deg, #FBBF24 0%, #F59E0B 100%)', shadow: '#B45309' };
  const isStoppedColor = { bg: 'linear-gradient(180deg, #4ADE80 0%, #16A34A 100%)', shadow: '#15803D' };
  const { bg: btnBg, shadow: shadowColor } = isRunning ? isRunningColor : isStoppedColor;

  return (
    <div className="module-template-container">
      <div className="module-template-card">
        <div className="module-template-content">
          {children}
        </div>

        <div className="module-template-progress">
          {Array.from({ length: totalQuestions }).map((_, idx) => (
            <div 
              key={idx} 
              className={`module-template-dot ${
                idx < progress.length 
                  ? progress[idx] 
                    ? 'correct' 
                    : 'wrong' 
                  : 'empty'
              }`} 
            />
          ))}
        </div>

        <div className="module-template-bottom-row">
          {/* НОВАЯ ГРУППА: Кнопки действий слева */}
          <div className="module-template-btns-group">
            <button 
              className="module-template-btn" 
              style={forceStop ? undefined : { background: btnBg }}
              onClick={forceStop ? handleForceStop : handleMainBtnClick}
              disabled={disabled}
            >
              <span className="module-template-btn-shadow" style={forceStop ? undefined : { background: shadowColor }}></span>
              <span className="module-template-btn-blink"></span>
              <span className="module-template-btn-blink-small"></span>
              <span className="module-template-btn-text">
                {forceStop ? 'СТОП' : (isRunning ? 'ПАУЗА' : 'СТАРТ')}
              </span>
            </button>

            {/* КНОПКА ПОВТОРА (появляется, только если передали onRepeat) */}
            {onRepeat && (
              <button className="module-template-repeat-btn" onClick={onRepeat}>
                🔊 Повторить
              </button>
            )}
           {extraButtons}
          </div>

          {extraContent && (
            <div className="module-template-extra">
              {extraContent}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ModuleTemplate;